var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.029,
    height: 36.03,
    viewBox: "0 0 36.029 36.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "title_4",
    "data-name": "title 4",
    transform: "translate(-1078.158 -500.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6507",
    "data-name": "Path 6507",
    d: "M1106.988,500.513h-21.64a7.206,7.206,0,0,0-7.19,7.2v21.63a7.206,7.206,0,0,0,7.19,7.2h21.64a7.187,7.187,0,0,0,7.2-7.19v-21.64A7.2,7.2,0,0,0,1106.988,500.513Zm-15.35,8.283h9.07v2h-3.3v10.36h-2.48V510.8h-3.29Zm10.31,22.687-.08.01h-11.39a.684.684,0,0,1-.59-.75.708.708,0,0,1,.51-.74l.08-.01h11.39a.692.692,0,0,1,.59.75A.708.708,0,0,1,1101.948,531.483Zm3.84-3.55-.13.01h-18.98a.892.892,0,0,1-.98-.76.867.867,0,0,1,.85-.74h19.11c.55,0,.98.33.98.75A.851.851,0,0,1,1105.788,527.933Z",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleIcon);
export default __webpack_public_path__ + "static/media/titleIcon.8bac962ddad980f3a01ac13de2097003.svg";
export { ForwardRef as ReactComponent };